import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faChevronRight } from "@fortawesome/free-solid-svg-icons"

export const ChevronRight = (props) => {
  return <FontAwesomeIcon faIcon={faChevronRight} {...props} />
}
